'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const KeyPicker = styled.div`
  max-width: 500px;
`;
